import { render, staticRenderFns } from "./AssignCollectionOfficerModal.vue?vue&type=template&id=2447dd3f&scoped=true&"
import script from "./AssignCollectionOfficerModal.vue?vue&type=script&lang=js&"
export * from "./AssignCollectionOfficerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2447dd3f",
  null
  
)

export default component.exports